<template>
  <transition name="fade">
    <div v-if="bellMenuVisible">
      <b-card no-body>
        <b-card-header style="padding: 0.5rem 0.5em">
          <b-row>
            <b-col>
              <h6 class = "mb-0 mt-1" style="color: green; font-weight: bold">{{numberOfUnseenNotification}} {{$tr('newMessages','new messages')}}</h6>
            </b-col>
            <b-col>
              <b-button-close
                  @click="closeMenuWindow()"
              >
              </b-button-close>
            </b-col>
          </b-row>
        </b-card-header>

        <b-card-body style="padding: 0.7rem;">
          <b-card-text v-if="numberOfUnseenNotification === 0 && numberOfUnreadNotifications === 0 ">
            <i style="font-style: normal">{{$tr('bellNotification.dontHaveNewOrUnReadMessages',"You don't have new or unread messages")}}</i>
          </b-card-text>

          <b-card-text v-else style="margin-bottom: 0.5rem" v-for="item in listOfTheLatestNotifications" :key="item.id">
            <b-link data-test-path="notification-message-unseen" @click="showDetailsNotification(item.id)">
              <li
                  data-test-path="notification-message-unseen-item"
                  style="font-weight: bold"
                  class="notifications-list"
                  v-if="item.seen === false"
              >
                <font-awesome-icon icon="envelope"/>
                <font-awesome-icon style="height: 13px; margin-bottom: 2px" :icon=item.iconClass.substr(7,item.iconClass.length) />
                {{item.headline }}
              </li>
            </b-link>
            <b-link data-test-path="notification-message-seen" @click="showDetailsNotification(item.id)">
              <li
                  class="notifications-list"
                  v-if="item.seen === true"
              >
                <font-awesome-icon icon="envelope" v-if="item.seen === true && item.read === false"/>
                <font-awesome-icon icon="envelope-open" v-else-if="item.seen === true && item.read === true"/>
                <font-awesome-icon style="height: 13px; margin-bottom: 2px" :icon=item.iconClass.substr(7,item.iconClass.length) />
                {{item.headline}}
              </li>
            </b-link>
          </b-card-text>
        </b-card-body>

        <b-card-footer style="padding: 0.5rem 0.5em">
          <b-row>
            <b-col class="text-left" style="white-space:nowrap">
              <b-link @click="showUserNotifications">{{ numberOfUnreadNotifications }} / {{numberOfAllNotifications}}{{$tr('unread','unread')}}  <span class="withoutMessages">{{$tr("messages","messages")}}</span></b-link>
            </b-col>
            <b-col class="text-right">
              <b-link @click="markAllNotificationsAsRead">{{$tr('markAllAsRead','Mark all as read')}}</b-link>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </div>
  </transition>
</template>

<script>
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import ActivityManager from "@/activity/ActivityManager";
const UserNotificationsPanel = () => require("@/components/notifications/UserNotificationsPanel");
import NotificationDetails from "@/components/notifications/NotificationDetails";


export default {
  name: "BellNotification",

  async beforeMount() {
    await this.countUnreadAndUnseenMessages();
    await this.loadNotifications();
  },

  async mounted() {
    this.$onEvent(ServerEvents.newNotification, this.reloadNotifications);
    this.$onEvent(Events.notificationsChanged, this.reloadNotifications);
  },

  methods: {


    async markAllNotificationsAsRead() {
      if (this.listOfTheLatestNotifications.length) {
        await Rpc.Notifications.markAllAsRead(this.listOfTheLatestNotifications[0].id);
        EventBus.$emit(Events.notificationsChanged);
        await this.countUnreadAndUnseenMessages();
      }
    },

    async showUserNotifications() {
      await ActivityManager.showActivity(UserNotificationsPanel);
      await this.closeMenuWindow();
      // EventBus.$emit(Events.hideBellOnClick);
    },

    async showDetailsNotification(id) {
      await ActivityManager.showActivity(NotificationDetails, {notificationId: id});
      await this.closeMenuWindow();
    },

    async closeMenuWindow() {
      this.$emit('hide-bell');
      if (this.listOfTheLatestNotifications.length > 0)
        await Rpc.Notifications.markAsSeen(this.listOfTheLatestNotifications[0].id);
      await this.countUnreadAndUnseenMessages();
      EventBus.$emit(Events.notificationsChanged);
    },

    async loadNotifications() {
      this.listOfTheLatestNotifications = await Rpc.Notifications.getLastUnseen(this.numberOfNotificationsOnBell);
      if (this.listOfTheLatestNotifications.length < this.numberOfNotificationsOnBell) {
        let unreadNotifications = await Rpc.Notifications.getLastUnread(this.numberOfNotificationsOnBell);
        let differenceBetweenUnseenAndUnread = _.differenceWith(unreadNotifications, this.listOfTheLatestNotifications, _.isEqual);
        for (let i = 0; i < differenceBetweenUnseenAndUnread.length; i++) {
          this.listOfTheLatestNotifications.push(differenceBetweenUnseenAndUnread[i]);
        }
      }
    },

    async reloadNotifications(){
      await this.loadNotifications();
      await this.countUnreadAndUnseenMessages();
    },

    async countUnreadAndUnseenMessages() {
      this.numberOfUnseenNotification = await Rpc.Notifications.countUnseen();
      this.numberOfUnreadNotifications = await Rpc.Notifications.countUnread();
      this.numberOfAllNotifications = await Rpc.Notifications.countAll();
    },

  },

  props: {
    bellMenuVisible:                     {type: Boolean,  default:false  },
  },

  data: () => ({
    listOfTheLatestNotifications: [],
    numberOfNotificationsOnBell: 5,
    numberOfUnseenNotification: 0,
    numberOfUnreadNotifications: 0,
    numberOfAllNotifications: 0,
  }),

}
</script>

